import gql from 'graphql-tag';

export const opportunityEconomyFragment = gql`{
  id 
  economy{id name improvement}
}`
